import { render, staticRenderFns } from "./PlaceImage.vue?vue&type=template&id=06816021&"
import script from "./PlaceImage.vue?vue&type=script&lang=js&"
export * from "./PlaceImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports